const actions = {
  SET_STATE: "user/SET_STATE",
  REGISTER: "user/REGISTER",
  LOAD_CURRENT_ACCOUNT: "user/LOAD_CURRENT_ACCOUNT",
  LOGOUT: "user/LOGOUT",
  ADD_USER: "user/ADD_USER",
  EDIT_USER: "user/EDIT_USER",
  EDIT_PREFERRED_CLINIC: "user/EDIT_PREFERRED_CLINIC",
  VERIFY_EMAIL: "user/VERIFY_EMAIL"
};

export default actions;
